const siteSearch = {

    elements: {},

    cacheDom()
    {
        this.elements.siteSearchButton = document.querySelector('.js-site-search');

        if( this.elements.siteSearchButton )
        {
            this.elements.siteSearchForm = this.elements.siteSearchButton.parentNode;
            this.elements.siteSearchField = this.elements.siteSearchForm.querySelector('input[type="text"]');
        }
    },

    hide() {
        this.elements.siteSearchButton.classList.remove('is-expanded');
        this.elements.siteSearchField.classList.remove('is-expanded');
    },

    show() {
        this.elements.siteSearchButton.classList.add('is-expanded');
        this.elements.siteSearchField.classList.add('is-expanded');
        this.elements.siteSearchField.focus();
    },

    bind()
    {
        const hideSearchInput = (e) => {
            if ( ! e.target.closest('.js-site-search-container') )
            {
                siteSearch.hide();
                document.removeEventListener( 'click', hideSearchInput );
            }
        }

        if( this.elements.siteSearchButton && this.elements.siteSearchForm )
        {
            this.elements.siteSearchButton.addEventListener('click', (e) => {

                e.stopPropagation();
                
                if( this.elements.siteSearchField.classList.contains('is-expanded') )
                {
                    this.elements.siteSearchField.value === ''
                        ? this.hide()
                        : this.elements.siteSearchForm.submit();
                }
                else
                {
                    this.show();
                    document.addEventListener('click', hideSearchInput );
                }
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default siteSearch;